import deleteUnnecessarySpaces from '../../../../services/deleteUnnecessarySpaces';

const commitChanges = async ({
  added,
  changed,
  deleted,
  rows,
  loaderFun,
  createCountry,
  updateCountry,
  deleteCountry,
  resetCreate,
  resetUpdate,
  enqueueSnackbar,
}) => {
  let changedRows;

  if (added) {
    if (resetUpdate) resetUpdate();
    const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
    changedRows = [
      ...rows,
      ...added.map((row, index) => ({
        id: startingAddedId + index,
        ...row,
      })),
    ];
    const currentCountry = {
      title: deleteUnnecessarySpaces(changedRows[rows.length].title),
      is_default: changedRows[rows.length].is_default || false,
    };

    if (currentCountry) {
      createCountry({ variables: { variables: currentCountry } }).then((result) => {
        if (result.data.createCountry) loaderFun.loadCountry();
      });
    }
  }

  if (changed) {
    if (resetCreate) resetCreate();
    const currentRows = [...rows];
    changedRows = rows.map((row) => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
    let editRowID;
    let editRow = {};
    for (let i = 0; i < currentRows.length; i += 1) {
      if (currentRows[i] !== changedRows[i]) {
        editRowID = changedRows[i].id;
        editRow = {
          title: deleteUnnecessarySpaces(changedRows[i].title),
          is_default: changedRows[i].is_default,
        };
      }
    }

    if (editRow) {
      updateCountry({ variables: { variables: editRow, id: editRowID } }).then((result) => {
        if (result.data.updateCountry) loaderFun.loadCountry();
      });
    }
  }
  if (deleted) {
    const deletedSet = new Set(deleted);
    deletedSet.forEach((id) => {
      deleteCountry({ variables: { id } })
        .then((result) => {
          if (result.data.deleteCountry) loaderFun.loadCountry();
        })
        .catch((e) => {
          if (enqueueSnackbar) {
            enqueueSnackbar(e.message, { variant: 'error' });
          } else {
            console.error('deleteCountry error:', e);
          }
        });
    });
  }
};

export default commitChanges;
